import { isReloy, isAdani } from "../../../../../../utils/isClient";
import SearchBar from "../../../../../Common/SearchBar";
import { arrowSvg, coinSvg, moneyBagSvg, priceDropSvg } from "../../svg";
import VerticalCarousel from "../../../../../Common/Carousel/VerticalCarousel";
import { getFont } from "../../../../../../utils/helpers";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function DealsHeaderLayout(props) {
  var searchValue = props.searchValue,
    onSearchChange = props.onSearchChange,
    internalWebview = props.internalWebview,
    config = props.config,
    isAuthenticated = props.isAuthenticated,
    appType = props.appType,
    _props$redux = props.redux,
    redux = _props$redux === void 0 ? {} : _props$redux,
    _props$router = props.router,
    router = _props$router === void 0 ? {} : _props$router;
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {},
    replace: function replace() {}
  };
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var authActions = redux === null || redux === void 0 ? void 0 : redux.authActions;
  var handlePriceDropClick = function handlePriceDropClick() {
    if (isReloy(config)) {
      return;
    }
    history.push("dealListing?tagID=-1&tagName=Price Drop Sale");
  };
  // const images = [
  //     'https://cdn.loyalie.in/connectre_website/1.jpg',
  //     'https://cdn.loyalie.in/connectre_website/2.jpg',
  //     'https://cdn.loyalie.in/connectre_website/3.jpg',
  //     'https://cdn.loyalie.in/connectre_website/4.jpg',
  // ];

  var images = [{
    desktop: "https://cdn.loyalie.in/connectre_website/4.jpg",
    mobile: "https://cdn.loyalie.in/connectre_website/4.jpg"
  }, {
    desktop: "https://cdn.loyalie.in/connectre_website/1.jpg",
    mobile: "https://cdn.loyalie.in/connectre_website/1.jpg"
  }, {
    desktop: "https://cdn.loyalie.in/connectre_website/2.jpg",
    mobile: "https://cdn.loyalie.in/connectre_website/2.jpg"
  }, {
    desktop: "https://cdn.loyalie.in/connectre_website/3.jpg",
    mobile: "https://cdn.loyalie.in/connectre_website/3.jpg"
  }];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex flex-col lg:flex-row text-white gap-x-5 cursor-pointer",
      children: /*#__PURE__*/_jsxs("div", {
        className: "w-full ".concat(internalWebview ? "sticky top-0 z-10 bg-white py-1 " : "" //internalWebview ? 'fixed top-0 z-10 w-[95%]  lg:w-[70%] pt-4 pb-1 bg-white'
        ),
        children: [" ", /*#__PURE__*/_jsx(SearchBar, {
          searchValue: searchValue,
          onSearchChange: onSearchChange,
          config: config,
          redux: redux,
          router: router
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "w-full h-full pt-4 lg:pt-10 pb-1",
      children: /*#__PURE__*/_jsx("p", {
        className: "text-md md:text-lg leading-[1.4]  ".concat(config !== null && config !== void 0 && config.darkMode ? 'text-white' : 'text-secondary-focus', " font-medium ").concat(isAdani(config) && config !== null && config !== void 0 && config.applyClientFonts ? (config === null || config === void 0 ? void 0 : config.fontBody) || '' : getFont((config === null || config === void 0 ? void 0 : config.name).toUpperCase()).body),
        children: "Your one-stop destination for everything you need. From home furnishings and services to finance and lifestyle upgrades, discover curated solutions designed to make everyday living easier."
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "w-full h-full ".concat(internalWebview ? "mt-4" : "mt-4"),
      children: [isReloy(config) && /*#__PURE__*/_jsx("img", {
        className: "w-full h-full md:h-auto object-cover rounded-xl cursor-default",
        src: "https://cdn.loyalie.in/1752570891334_THT_OFFERS"
      }), isAdani(config) && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("img", {
          className: "w-full h-full md:h-auto object-cover rounded-xl cursor-default hidden md:block",
          src: "https://cdn.loyalie.in/1787046613152_Deals_Banner_LG"
        }), /*#__PURE__*/_jsx("img", {
          className: "w-full h-full md:h-auto object-cover rounded-xl cursor-default block md:hidden",
          src: "https://cdn.loyalie.in/1787046652730_Deals_Banner_SM"
        })]
      }), !isReloy(config) && !isAdani(config) && /*#__PURE__*/_jsx(VerticalCarousel, {
        images: images
      })]
    })]
  });
}